<template>
  <div class="basicContainer">
    <!-- 组件传参方式 不显示 返回 按钮 -->
    <div class="headerTitle" v-if="!answerId">
      <el-page-header @back="goBack"></el-page-header>
    </div>
    <div
      class="flex justify-between items-center hover:bg-blue hover:bg-opacity-25"
    >
      <div class="jTit">多媒体资料</div>
      <el-button @click="() => (mediaContentShow = !mediaContentShow)" type="text">{{ mediaContentShow ? '收起' : '展开' }}</el-button>
    </div>
    <div class="musicBox" v-show="mediaContentShow">
      <div class="musicTit">问卷图片</div>
      <el-table :data="imageSurveyUrlArr" border style="width: 100%">
        <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>
        <el-table-column prop="date" align="center" label="位置">
          <template slot-scope="scope">
            <template>
              <span v-html="transformHtml(convertAnswerText(scope.row.text, answerContent))"></span>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="dates" align="center" label="资料名称">
          <template slot-scope="scope">
            <template>
              <span @click="downloadIamge(scope.row.imgArr, scope.row.name)" v-html="transformHtml(scope.row.name)"> </span>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="name" align="center" label="资料">
          <template slot-scope="scope">
            <div class="demo-image__preview">
              <img
                style="width: 30px; height: 30px; cursor: pointer"
                v-for="(imgSrc, index) in scope.row.imgArr"
                :src="imgSrc"
                :key="index"
                :z-index="4000"
                @click="onPreview(imageSurveyUrlArr.indexOf(scope.row), 1)"
              />
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="jTits">开放题和非开放题</div>
    <el-table class="answer1" :data="feikaiArr" border style="width: 100%">
      <el-table-column type="index" label="序号" width="50">
        <template slot-scope="scope">
          {{ scope.row.questionNo }}
        </template>
      </el-table-column>
      <el-table-column prop="date" label="题干" width="300">
        <template slot-scope="scope">
          <stem-col :row="scope.row" :answerContent="answerContent"></stem-col>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="答案">
        <template slot-scope="scope">
          <h1 class="question-description" v-if="scope.row.questionDetails && scope.row.questionDetails.note" v-html="transformHtml(scope.row.questionDetails && scope.row.questionDetails.note)"></h1>
          <answer-col
            :row="scope.row"
            :questionType="scope.row.questionType"
            :answerItems="scope.row.items"
            :getAppendItems="getAppendItems"
            :additional="additional"
            @on-preview="onPreview"
          ></answer-col>
        </template>
      </el-table-column>
      <el-table-column prop="score" label="得分" width="80">
        <template slot-scope="scope">
          {{ scope.row.score }}
        </template>
      </el-table-column>
      <el-table-column prop="duration" label="答题时长" width="100">
        <template slot-scope="scope"> {{ scope.row.duration / 1000 }}s </template>
      </el-table-column>
    </el-table>
    <!-- 点击预览 大图 -->
    <el-image-viewer
      v-if="showViewer"
      :initialIndex="curIndex"
      :on-close="closeViewer"
      :on-switch="onSwitch"
      :url-list="url"
      :z-index="5000"
    />
    <audio-play
      v-if="currentAudio"
      :audio="currentAudio"
      :duringCallContent="duringCallContent"
      @closeAudioPlay="closeAudioPlay"
    ></audio-play>
  </div>
</template>
<script>
import JSZip from 'jszip'
import FileSaver from 'file-saver'
import { detail, getPasswordInfo } from '@/api/wenjuan/answerList'
import mixins from './mixins-recycle'
import { channel_list_options, typeConfig } from '@/components/survey-detail/config/index.js'
import ElImageViewer from 'dygc-ui/packages/image/src/image-viewer'
import AnswerCol from './AnswerCol'
import StemCol from './StemCol'
import AudioPlay from './AudioPlay.vue'
import { getQuestionNo, getColsestDif, isPreNo, getAppendItems, getAppendOptions, getRemainder } from './detailMeans.js'
import { transformHtml } from '@/components/survey-detail/utils/index.js'
import { convertAnswerText } from '@/question/convert.js'
export default {
  name: 'AnswerDetail',
  mixins: [mixins],
  components: { ElImageViewer, AnswerCol, StemCol, AudioPlay },
  directives: {
    playbackRate(el, binding) {
      el.playbackRate = binding.value
    }
  },
  props: {
    answerId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isEnlargeImage: false, //放大图片
      enlargeImage: '', //放大图片地址
      rateOptions: [
        {
          value: 0.5,
          label: '0.5倍速'
        },
        {
          value: 1.0,
          label: '1.0倍速'
        },
        {
          value: 1.5,
          label: '1.5倍速'
        },
        {
          value: 2.0,
          label: '2.0倍速'
        },
        {
          value: 4.0,
          label: '4.0倍速'
        },
        {
          value: 8.0,
          label: '8.0倍速'
        }
      ],
      // 经纬度
      lng: '',
      lag: '',
      // 问题与答案
      feikaiArr: [],
      audioUrls: [],
      videoUrls: [],
      imageGlobalUrls: [],
      imageSurveyUrlArr: [],
      signUrlArr: [],
      downloadUrl: '', //文件上传题 下载地址
      // -------=--
      //   imgUrl:
      //     "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
      srcList: [],
      audio: {
        // 该字段是音频是否处于播放状态的属性
        playing: false
      },
      title: '数量',
      batchFlag: false,
      batchNoFlag: false,
      typeConfig,
      channel_list_options,
      answerContent: [],
      form: {
        answerID: '',
        quesName: '',
        answerType: '',
        // initialStatus: "",
        channel: '',
        zqd: '',
        taskName: '',
        endTime: '',
        upTime: '',
        titId: '',
        qd: '',
        user: '',
        dz: '',
        jwd: '',
        startExamTime: '',
        endUser: '',
        endExamTime: '',
        degree: '',
        answerTime: '',
        startTime: '',
        longTime: '',
        ip: '',
        // 答题样本 id name
        accountUserId: '',
        accountUsername: '',
        // 答题密码+附加属性
        password: '',
        property: '',
        // 样本属性
        relatedSampleId: '',
        sampleName: '',
        samplePhone: '',
        sampleResidence: '',
        // 质控人
        auditId: '',
        auditName: '',
        auditTime: '',
        submitTime: ''
      },
      tableData: [],
      showViewer: false,
      url: [],
      currentImgName: '',
      curIndex: 0,
      quesType: 0,
      picItem: {},
      duringCallContent: [],
      isAlert: false,
      audios: [],
      amountIssue: 0,
      audioTime: 0,
      minScroll: 0,
      maxScroll: 0,
      isScroll: false,
      currentAudio: '',
      mediaContentShow: false
    }
  },
  computed: {
    mediaLen() {
      return this.audioUrls.length + this.videoUrls.length + this.imageSurveyUrlArr.length + this.imageGlobalUrls.length
    }
  },
  methods: {
    convertAnswerText,
    transformHtml,
    getQuestionNo,
    getColsestDif,
    isPreNo,
    onRefresh(aswId) {
      if (aswId) {
        this.getDetail(aswId)
      }
    },
    closeAudioPlay() {
      this.currentAudio = ''
    },
    showAudioPlay(row) {
      this.currentAudio = row
    },
    onPreview(index, type, item) {
      if (type == 1) {
        let num = 0
        for (let i = 0; i <= index; i++) {
          if (!this.imageSurveyUrlArr[i].imgArr.length) {
            num++
          }
        }
        index -= num
      }
      this.showViewer = true
      this.curIndex = index
      this.quesType = type
      this.picItem = item
      this.additional(index)
    },
    // 关闭查看器
    closeViewer() {
      this.showViewer = false
    },
    handleFormData(answerList) {
      this.answerContent = answerList.answerContent
      this.form.answerID = answerList.id
      this.form.serialNumber = answerList.serialNumber // 流水编号
      this.form.quesName = answerList.surveyTitle
      this.form.answerType = answerList.status
      this.form.qd = this.channel_list_options[answerList.channel]
      this.form.channel = answerList.channel
      this.form.zqd = answerList.answerChannel
      this.form.taskName = answerList.taskName // 任务名称
      this.form.startTime = answerList.surveyStartTime
      this.form.endTime = answerList.surveyFinishTime
      this.form.upTime = answerList.submitTime //answerList.surveyFinishTime
      this.form.longTime = answerList.surveyDuration
      this.form.ip = answerList.ipAddress
      this.form.dz = answerList.answerAddress
      if (answerList.surveyLon == null || answerList.surveyLat == null) {
        this.form.jwd = ''
      } else {
        this.form.jwd = answerList.surveyLon + ',' + answerList.surveyLat
      }
      this.lng = answerList.surveyLon
      this.lag = answerList.surveyLat
      this.form.user = (answerList.supervisorId && answerList.supervisorId + '-' + answerList.supervisorName) || ''
      this.form.accountUserId = answerList.accountUserId
      this.form.accountUsername = answerList.accountUsername
      this.form.relatedSampleId = answerList.relatedSampleId // 样本id
      this.form.sampleName = answerList.sampleName // 样本名
      this.form.samplePhone = answerList.samplePhone // 样本电话
      this.form.sampleResidence = answerList.sampleResidence // 样本常住地址
      this.form.auditId = answerList.auditId // 质控员id
      this.form.auditName = answerList.auditName // 质控员
      this.form.auditTime = answerList.auditTime // 质控时间
      this.form.submitTime = answerList.submitTime // 提交时间
      this.form.startExamTime = answerList.reviewTime
      this.form.interviewerName = answerList.interviewerName
      this.form.interviewerTelephone = answerList.interviewerTelephone
      this.form.awardYuanAmount = answerList.awardYuanAmount // 普通红包
      this.form.shareAwardYuanAmount = answerList.shareAwardYuanAmount // 分享红包
      this.form.callee = answerList.callee // 相关手机号
      this.form.calleeName = answerList.calleeName // 被叫姓名
      // 20200830 质控驳回时 显示原因
      this.form.degree = answerList.status === 10 ? answerList.rejectReason : answerList.auditDescription
      //   音频重组
      this.audioUrlsFun(answerList)
      //   视频重组
      this.videoUrlsFun(answerList)
      //   图片重组（拆分为 全局图片和问卷图片）
      this.picGlobalFun(answerList)
      this.picSurveyFun(answerList)
      // 签名重组
      this.signFun(answerList)
      //   问卷问题及答案修改
      this.quesFun(answerList.answerContent)
      this.duringCallContent = answerList
    },
    // 控制音频的播放与暂停
    startPlayOrPause() {
      return this.audio.playing ? this.pause() : this.play()
      //   this.play();
    },
    // 播放音频
    play() {
      this.$refs.audio.play()
    },
    // 暂停音频
    pause() {
      this.$refs.audio.pause()
    },
    // 当音频播放
    onPlay() {
      this.audio.playing = true
    },
    // 当音频暂停
    onPause() {
      this.audio.playing = false
    },
    // 音频canplay
    getDuration() {
      let audioArr = document.getElementsByClassName('audios')
      let time = 0
      audioArr.forEach(element => {
        time += element.duration
      })
      this.audioTime = parseInt(time)
      let amountIssue = 0
      this.duringCallContent.answerContent.forEach(item => {
        item.questionType != 20 ? (amountIssue += 1) : ''
      })
      this.amountIssue = amountIssue
      this.isAlert = true
    },
    //  返回
    goBack() {
      this.$router.back()
    },
    //  通过
    yesCli() {
      this.batchFlag = true
    },
    noCli() {
      this.batchNoFlag = true
    },
    // 图片下载
    downloadIamge(imgsrc, name) {
      // 打包
      var blogTitle = name
      var zip = new JSZip()
      var imgs = zip.folder(blogTitle)
      var baseList = []
      var imgNameList = '1'
      var arr = imgsrc

      for (var i = 0; i < arr.length; i++) {
        let image = new Image()
        // 解决跨域 Canvas 污染问题
        image.setAttribute('crossOrigin', 'anonymous')

        image.onload = function () {
          let canvas = document.createElement('canvas')
          canvas.width = image.width
          canvas.height = image.height

          let context = canvas.getContext('2d')
          context.drawImage(image, 0, 0, image.width, image.height)

          let url = canvas.toDataURL() // 得到图片的base64编码数据
          canvas.toDataURL('image/png')

          baseList.push(url.substring(22)) // 去掉base64编码前的 data:image/png;base64,
          if (baseList.length === arr.length && baseList.length > 0) {
            for (let k = 0; k < baseList.length; k++) {
              imgs.file(imgNameList[k] + '.png', baseList[k], { base64: true })
            }
            zip.generateAsync({ type: 'blob' }).then(function (content) {
              // see FileSaver.js
              FileSaver.saveAs(content, blogTitle + '.zip')
            })
          }
        }
        image.src = arr[i]
      }
    },
    // 问卷问题及答案的重组
    quesFun(data) {
      this.feikaiArr = data.filter(item => {
        if (
          item.questionType == 1 ||
          item.questionType == 2 ||
          item.questionType == 3 ||
          item.questionType == 4 || // 开放题----填空题
          item.questionType == 7 || // 开放题----单行文本填充题
          item.questionType == 8 || // 开放题----多行文本填充题
          item.questionType == 5 ||
          item.questionType == 6 ||
          item.questionType == 9 ||
          item.questionType == 10 ||
          item.questionType == 11 ||
          item.questionType == 12 ||
          item.questionType == 13 ||
          item.questionType == 14 || // 手写签名
          item.questionType == 15 ||
          item.questionType == 16 ||
          item.questionType == 17 ||
          item.questionType == 18 ||
          item.questionType == 19 || // 详细地址
          item.questionType == 100 || // 所在位置
          item.questionType == 20 || // 描述题
          item.questionType == 21 ||
          item.questionType == 22 || // 姓名
          item.questionType == 23 || // 手机号
          item.questionType == 24 || // 邮箱
          item.questionType == 27 || // 性别
          item.questionType == 28 || // 常住地
          item.questionType == 29 || // 出生日期
          item.questionType == 31 || // 身份证
          item.questionType == 32 || // 年龄
          item.questionType == 33 || // 户籍
          item.questionType == 34 || // 学历
          item.questionType == 35 || // 大学专业
          item.questionType == 36 || // 院校
          item.questionType == 37 || // 所处行业
          item.questionType == 38 || // 职业
          item.questionType == 39 || // 婚姻状况
          item.questionType == 40 || // 个人月收入
          item.questionType == 101 || // 旧版题型（矩阵下拉，矩阵天空）兼容用
          item.questionType == 102 || // 自增表格
          item.questionType == 103 || // 矩阵滑动
          item.questionType == 104 || // 比重题
          item.questionType == 105 || // 多项填空
          item.questionType == 106 || // 矩阵下拉题
          item.questionType == 107 || // 矩阵填空题
          item.questionType == 109 || // 手机验证题
          item.questionType == 110 || // 表格组合
          item.questionType == 111 || //分类题
          item.questionType == 112 || // 可下载附件
          item.questionType == 113 || // 图片选择（单选）
          item.questionType == 117 || // 图片选择(多选)
          item.questionType == 109 || // 手机验证
          item.questionType == 114 ||// 区划代码
          item.questionType == 119 ||// 加总题
          item.questionType == 124  //maxDiff题
        ) {
          return item
        }
      })
      console.log(this.feikaiArr)
      this.feikaiArr.length && this.getQuestionNo()
    },
    getDownloadList(list, tag = 'url') {
      console.log(list)
      let imgList =
        list !== null &&
        list.map(item => {
          return this._getDownloadUrl(item[tag])
        })
      return imgList
    },
    // 单选
    getImg(row) {
      // console.log(row);
      var answerArr = ''
      if (row && row.questionDetails && row.questionDetails.issue) {
        const a = row.questionDetails.issue.items
        for (var i = 0; i < a.length; i++) {
          if (row.items && row.items[0].optionId === a[i].id) {
            if (Array.isArray(a[i].content.image) && a[i].content.image.length !== 0) {
              answerArr = this._getDownloadUrl(a[i].content.image[0].url ? a[i].content.image[0].url : '')
            }
          }
        }
      }
      // console.log(answerArr);
      return answerArr
    },
    //除单选外 统一获取带有图片的答案的方法
    getAnswer(row, item) {
      var answerArr = []
      if (row && row.questionDetails && row.questionDetails.issue) {
        for (var i = 0; i < row.items.length; i++) {
          for (var j = 0; j < item.length; j++) {
            if (row.questionType == 2 || row.questionType == 11) {
              var issueId = row.items[i].optionId
              var itemId = item[j].id
            } else if (row.questionType == 5 || row.questionType == 6) {
              if (item == row.questionDetails.issue.items) {
                var issueId = row.items[i].colId
                var itemId = item[j].id
              } else if (item == row.questionDetails.issue.rows) {
                var issueId = row.items[i].rowId
                var itemId = item[j].row_id
              }
            }
            let tipText1 = row.items.find(item => {
              if (item.value.indexOf('|') != -1) {
                return item
              }
            })
            if (issueId == itemId) {
              if (Array.isArray(item[j].content.image) && item[j].content.image.length !== 0) {
                if (tipText1 && tipText1.value && tipText1.optionId && tipText1.optionId == issueId) {
                  const t = tipText1.value.split('|')[1] || ''
                  answerArr.push([
                    {
                      url: this._getDownloadUrl(item[j].content.image ? item[j].content.image[0].url : ''),
                      richText: item[j].content.richText ? item[j].content.richText + (t && ' | ' + t) : null,
                      text: item[j].content.text ? item[j].content.text + (t && ' | ' + t) : null
                    }
                  ])
                } else {
                  answerArr.push([
                    {
                      url: this._getDownloadUrl(item[j].content.image ? item[j].content.image[0].url : ''),
                      richText: item[j].content.richText ? item[j].content.richText : null,
                      text: item[j].content.text ? item[j].content.text : null
                    }
                  ])
                }
              } else {
                if (tipText1 && tipText1.value && tipText1.optionId && tipText1.optionId == issueId) {
                  const t = tipText1.value.split('|')[1] || ''
                  answerArr.push([
                    {
                      richText: item[j].content.richText ? item[j].content.richText + (t && ' | ' + t) : null,
                      text: item[j].content.text ? item[j].content.text + (t && ' | ' + t) : null
                    }
                  ])
                } else {
                  answerArr.push([
                    {
                      richText: item[j].content.richText ? item[j].content.richText : null,
                      text: item[j].content.text
                    }
                  ])
                }
              }
            }
          }
        }
      }
      return answerArr
    },
    getUrl(item) {
      const index = item.lastIndexOf('/')
      return item.slice(index + 1)
    },
    getRadioHtml(row) {
      let tipText = ''
      if (row.items && row.items[0] && row.items[0].value) {
        tipText = row.items[0].value.split('|')[1] || ''
      }
      for (let i = 0; i < row.questionDetails.issue.items.length; i++) {
        if (row.questionDetails.issue.items[i].id == row.items[0].optionId) {
          const content = row.questionDetails.issue.items[i].content
          return content.richText ? content.richText + (tipText && ' | ' + tipText) : content.text + (tipText && ' | ' + tipText)
        }
      }
    },
    isImg(url) {
      //文件路径
      var fileName = url
      //后缀获取
      let suffix = ''
      // 获取类型结果
      let result = ''
      const flieArr = fileName.split('.')
      suffix = flieArr[flieArr.length - 1]
      if (suffix != '') {
        suffix = suffix.toLocaleLowerCase()
        // 图片格式
        const imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif']
        // 进行图片匹配
        result = imglist.find(item => item === suffix)
        if (result) {
          return true
        } else {
          return false
        }
      }
    },
    additional(index) {
      this.url = []
      if (this.quesType == 1) {
        for (let i = 0; i < this.imageSurveyUrlArr.length; i++) {
          if (this.imageSurveyUrlArr[i].imgArr.length) {
            this.url.push(this.imageSurveyUrlArr[i].imgArr[0])
            this.currentImgName = this.imageSurveyUrlArr[index].name
          }
        }
      }
      if (this.quesType == 2) {
        for (let i = 0; i < this.feikaiArr.length; i++) {
          if (this.feikaiArr[i].questionType == 18 && this.feikaiArr[i].items.indexOf(this.picItem) >= 0) {
            for (let j = 0; j < this.feikaiArr[i].items.length; j++) {
              this.url.push(this._getDownloadUrl(this.feikaiArr[i].items[j].value))
              this.currentImgName = this.getUrl(this.feikaiArr[i].items[index].value)
            }
          }
        }
      } else if (this.quesType == 3) {
        for (let i = 0; i < this.imageGlobalUrls.length; i++) {
          if (this.imageGlobalUrls[i].imgArr) {
            this.url.push(this.imageGlobalUrls[i].imgArr)
            this.currentImgName = this.imageGlobalUrls[index].name
          }
        }
      }
      this.addNode()
    },
    addNode() {
      this.$nextTick(() => {
        if (document.getElementById('newNode')) {
          document.getElementById('newNode').remove()
        }
        let fatherNode = document.getElementsByClassName('el-image-viewer__canvas')
        let afterNode = document.getElementsByClassName('el-image-viewer__img')
        let newNode = document.createElement('div')
        newNode.innerText = '资料名称：' + this.currentImgName
        newNode.style.cssText =
          'color:#fff; font-size:14px;  text-align: center; position: absolute; top:13px; width:auto; z-index:5000; background: rgba(000,000,000,0.38); padding:0px 10px; border-bottom-right-radius: 12px; border-radius: 12px;'
        newNode.setAttribute('id', 'newNode')
        fatherNode[0].insertBefore(newNode, afterNode[0])
      })
    },
    onSwitch(index) {
      this.additional(index)
    },
    getBool() {
      if (this.form.channel !== '' && this.form.channel !== 2 && this.form.channel !== 9) {
        return true
      } else {
        return false
      }
    },
    getAppendItems,
    getAppendOptions,
    getRemainder,
    getDetail(aswId) {
      let detailPromise = detail(aswId)
      let getPasswrodInfoPromise = getPasswordInfo({ answerId: aswId })
      Promise.all([detailPromise, getPasswrodInfoPromise])
        .then(res => {
          this.handleFormData((res[0].data && res[0].data.data) || [])
          if (res[1].data.data) {
            this.form.password = res[1].data.data.password || ''
            this.form.property = res[1].data.data.property || ''
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  created() {
    let aswId
    if (this.$route) {
      aswId = this.$route.query.answerId
    }
    if (this.answerId) {
      aswId = this.answerId
    }
    this.getDetail(aswId)
  },
  watch: {
    answerId(n) {
      if (n) this.getDetail(n)
    }
  }
}
</script>
<style scoped lang="scss">
.flex {
  display: flex;
}
.headerTitle {
  text-align: center;
  width: 100%;
  height: 40px;
  line-height: 40px;
  font-size: 20px;
  font-weight: bolder;
  border-bottom: solid 1px #ebeef5;
  position: relative;

  .btnBox {
    display: inline-block;
    position: absolute;
    right: 0px;
    top: -13px;
  }
}

.content {
  font-weight: normal;
  color: #ccc;

  span {
    padding: 0 10px;
    font-weight: normal;
    font-size: 14px;
    color: #000;
  }

  b {
    padding-left: 10px;
    color: #000;
  }
}
::v-deep.el-image-viewer__btn,
.el-image-viewer__close {
  // background: transparent!important;
  // right: 200px;
  .el-icon-circle-close,
  .el-icon-close {
    color: white;
  }
}
::v-deep.el-image-viewer__img {
  width: 50% !important;
  height: auto !important;
  position: absolute !important;
  top: 40px;
}
.jT_content {
  .jT_c_s {
    padding: 16px 10px;
    border-bottom: solid 1px #e8e8e8;

    .el-col {
      margin-top: 16px;
      height: 22px;
      line-height: 22px;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
      span {
        color: rgba(0, 0, 0, 0.65);
      }
      &.quesName {
        .label {
          font-size: 14px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.85);
          width: 70px;
        }
        span {
          max-width: calc(100% - 70px);
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }

  .jT_c_z {
    display: flex;
    padding: 16px 10px;
    border-bottom: solid 1px #e8e8e8;

    .left {
      flex: 2;
      height: 380px;

      p {
        margin-top: 13px;
        height: 18px;
        line-height: 18px;
        .d {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.85);
        }
        span {
          line-height: 22px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          display: inline-block;
          padding-left: 5px;
          font-size: 14px;
          font-family: HelveticaNeue;
          color: rgba(0, 0, 0, 0.65);
        }
      }
    }

    .right {
      flex: 3;
      height: 360px;
    }
  }

  .jT_c_x {
    padding: 5px 10px;
    min-height: 50px;
    display: table;
    p {
      line-height:120%;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.85);
      display: table-cell;
      vertical-align:middle;
      span {
        padding-left: 5px;
        font-size: 14px;
        font-family: HelveticaNeue;
        color: rgba(0, 0, 0, 0.65);
      }
    }
  }
}

.jTit {
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(48, 49, 50, 1);
}

.jTits {
  margin-top: 10px;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(48, 49, 50, 1);
  height: 50px;
  line-height: 50px;
}
.answer1 {
  ::v-deep.cell {
    // display: flex;
    // align-items: center;
  }
  ::v-deep .cell {
    line-height: 40px;
  }
}
.musicBox {
  width: 100%;

  .musicTit {
    height: 50px;
    line-height: 50px;
  }
}

// .el-form-item ::v-deep .el-input__inner {
//   border: none;
//   background: #fff;
// }
.inputs ::v-deep .el-input__inner {
  border: none !important;
  background: #fff !important;
}

.el-form-item {
  margin-bottom: 0;
}

// 音频
.el-table ::v-deep .cell {
  position: relative;
}

.audios {
  height: 30px;
}

.audioA {
  position: absolute;
  left: 20px;
  top: 5px;
}

.videoDialog ::v-deep .el-dialog {
  width: 100%;
  height: 100%;
}

.videoDialog ::v-deep .el-dialog__header {
  padding-bottom: 30px;
  background-color: black;
}

.videoDialog ::v-deep .el-dialog__body {
  background: black;
  padding: 0;
}
.videoDialog ::v-deep .el-icon-video-play {
  font-size: 16px;
}
.alert-style {
  color: #000;
  font-size: 16px;
  font-weight: 400;
}
::v-deep.el-alert--warning.is-light {
  background-color: rgb(252, 248, 228);
  border: 1px solid rgb(254, 228, 148);
  margin-bottom: 10px;
}
::v-deep.el-alert--info.is-light {
  background-color: rgb(231, 247, 255);
  border: 1px solid rgb(148, 214, 253);
  margin-bottom: 10px;
}
// 隐藏滚动条
::-webkit-scrollbar {
  display: none;
}
::v-deep.cell span p {
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>
